import analytics from '@react-native-firebase/analytics';

// Analytics service for tracking user events
export const analyticsService = {
    // Log app open event
    logAppOpen: async () => {
        try {
            await analytics().logAppOpen();
            console.log('Analytics: App open logged');
        } catch (error) {
            console.warn('Analytics logAppOpen error:', error);
        }
    },

    // Log login event
    logLogin: async (method: string = 'email') => {
        try {
            await analytics().logLogin({ method });
            console.log('Analytics: Login logged');
        } catch (error) {
            console.warn('Analytics logLogin error:', error);
        }
    },

    // Log screen view
    logScreenView: async (screenName: string, screenClass?: string) => {
        try {
            await analytics().logScreenView({
                screen_name: screenName,
                screen_class: screenClass || screenName,
            });
            console.log(`Analytics: Screen view logged - ${screenName}`);
        } catch (error) {
            console.warn('Analytics logScreenView error:', error);
        }
    },

    // Log custom event
    logEvent: async (eventName: string, params?: Record<string, any>) => {
        try {
            await analytics().logEvent(eventName, params);
            console.log(`Analytics: Event logged - ${eventName}`);
        } catch (error) {
            console.warn('Analytics logEvent error:', error);
        }
    },

    // Set user ID for analytics
    setUserId: async (userId: string | null) => {
        try {
            await analytics().setUserId(userId);
            console.log(`Analytics: User ID set - ${userId}`);
        } catch (error) {
            console.warn('Analytics setUserId error:', error);
        }
    },

    // Set user property
    setUserProperty: async (name: string, value: string | null) => {
        try {
            await analytics().setUserProperty(name, value);
            console.log(`Analytics: User property set - ${name}: ${value}`);
        } catch (error) {
            console.warn('Analytics setUserProperty error:', error);
        }
    },
};

export default analyticsService;

